import { makeStyles } from "@material-ui/core/styles";
import React, { createContext, useState } from "react";
import SideBar, { WIDTH as sideBarWidth } from "../../components/SideBar";
import Catalogo from "./desktop/Catalogo";
import Clientes from "./desktop/Clientes";
import Inicio from "./desktop/Inicio";
import Pedidos from "./desktop/Pedidos";
import PerfilTienda from "./desktop/PerfilTienda";
import Billetera from "./desktop/Billetera";

export const DestktopContext = createContext("DestktopContext");

const useStyles = makeStyles(theme => ({
  main: {
    minHeight: "100vh",
    marginLeft: sideBarWidth
  }
}));

const Desktop = () => {
  const classes = useStyles();
  const [active, setActive] = useState("inicio");

  const context = {
    pedidosView: { open: false, tipo: "" }
  };

  const View = () => {
    switch (active) {
      case "pedidos_recibidos":
        return <Pedidos tipo="recibidos" />;
      case "pedidos_abandonados":
        return <Pedidos tipo="abandonados" />;
      case "pedidos_archivados":
        return <Pedidos tipo="archivados" />;
      case "catalogo":
        return <Catalogo />;
      case "clientes":
        return <Clientes />;
      case "perfil_tienda":
        return <PerfilTienda />;
      case "billetera":
        return <Billetera />;
      default:
        return <Inicio />;
    }
  };

  return (
    <DestktopContext.Provider value={context}>
      <SideBar
        onInicio={() => setActive("inicio")}
        onPedidosRecibidos={() => setActive("pedidos_recibidos")}
        onPedidosAbandonados={() => setActive("pedidos_abandonados")}
        onPedidosArchivados={() => setActive("pedidos_archivados")}
        onCatalogo={() => setActive("catalogo")}
        onClientes={() => setActive("clientes")}
        onTienda={() => setActive("perfil_tienda")}
        onUsuario={() => setActive("perfil_usuario")}
        onBilletera={() => setActive("billetera")}
      />

      <main className={classes.main}>
        <View />
      </main>
    </DestktopContext.Provider>
  );
};

export default Desktop;
